export type { BaseRequiredDocumentResponse as RequiredDocument } from '@lendi/required-documents-common';

// ProductSelections
type RelationshipData = {
  id: string;
  type: string;
};

type RelationshipLink = {
  self: string;
  related: string;
};

export interface Relationship {
  funder?: {
    data: RelationshipData;
    links?: RelationshipLink;
  };
  package?: {
    data: RelationshipData;
    links?: RelationshipLink;
  };
  structure?: {
    data: RelationshipData;
    links?: RelationshipLink;
  };
  products?: {
    data?: RelationshipData[];
    links?: RelationshipLink;
  };
}

export interface Resource<T extends string = string, A extends {} = { [name: string]: any }> {
  id: string;
  type: T;
  attributes?: A;
  // make relationships specific because the data property inside can be either an array or object
  relationships?: Relationship;
  links?: any;
}

export interface ProductSelections {
  data: Resource[];
  included?: Resource[];
}

// RequiredActionCondition
export enum ConditionStatus {
  Opened = 'Opened',
  UserMitigated = 'UserMitigated',
  SystemMitigated = 'SystemMitigated',
}
export interface ConditionDetail {
  allowBrokerMitigation: boolean;
  allowCustomerMitigation: boolean;
  commentRequired: boolean;
  description: string;
  hardstop: boolean;
  includedInCoversheet: boolean;
  mitigationDescription: string;
  override: boolean;
  requiredDocTypes: string[];
  ruleCategory: string;
  ruleId: string;
  ruleName: string;
  ruleVersion: number;
  variationOnly: boolean;
  selectedLenderId?: string;
}

export enum ConditionRequiredDocStatus {
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  FAILED_VERIFICATION = 'FAILED_VERIFICATION',
  EXPIRED = 'EXPIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  VERIFIED = 'VERIFIED',
}

export interface ConditionRequiredDoc {
  documentId: string;
  docType: string;
  applicantId: string;
  status: ConditionRequiredDocStatus;
}

export interface RequiredActionCondition {
  applicationId: string;
  comment: string | null;
  detail?: ConditionDetail;
  id: string;
  status: ConditionStatus;
  version: number;
  requiredDocuments: ConditionRequiredDoc[];
}
